import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Box } from '@salesforce/retail-react-app/app/components/shared/ui';
import { useBazarVoice } from '../../../integrations/bazarvoice/hooks/use-bazarvoice';
import {sendLoadReviewEvent} from '../../../utils/gtm-utils'

const LoadMore = ({ pid, product, reviews, setReviewsData }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [startUpdate, setStartUpdate] = useState(false);
    const [page, setPage] = useState(reviews?.options?.page);
    const [sort, setSort] = useState(reviews?.options?.sort);
    const {reviews: nextReviews} = useBazarVoice({pid, page, sort});

    const handleLoadMore = () => {
        const nextPage = page + 1;
        setStartUpdate(true);
        setPage(nextPage);
        setSort(reviews.options.sort);
    }

    useEffect(() => {
        if (nextReviews && page > 0) {
            // GTM Modification
            sendLoadReviewEvent(product, nextReviews)

            setReviewsData((prevReviews) => ({
                options: {
                    ...reviews.options,
                    page: page + 1
                },
                reviews: {
                    ...prevReviews.reviews,
                    Offset: nextReviews.Offset,
                    Results: [...prevReviews.reviews.Results, ...nextReviews.Results]
                }
            }));
            setStartUpdate(false);
        }
    }, [nextReviews])

    useEffect(() => {
        if (reviews) {
            setIsVisible(reviews?.reviews?.TotalResults > reviews?.reviews?.Limit && reviews?.reviews?.Results?.length !== reviews?.reviews?.TotalResults)
        }
    }, [reviews])

    useEffect(() => {
        setPage(0);
    }, [reviews?.options?.sort])

    return (
        <Box>
            {isVisible &&
                <Button
                    variant="webSecondaryOutline"
                    maxW={{base: '250px'}}
                    w={{base: "100%"}}
                    maxWidth={'203px'}
                    onClick={handleLoadMore}
                    isLoading={startUpdate} >
                    <FormattedMessage
                        defaultMessage="Load More"
                        id="pdp_reviews.load.more"
                    />
                </Button>
            }
        </Box>
    );
};

LoadMore.propTypes = {
    pid: PropTypes.string,
    product: PropTypes.object,
    reviews: PropTypes.object,
    setReviewsData: PropTypes.func
};

export default LoadMore;
